import { render, staticRenderFns } from "./scan-fingerprint.vue?vue&type=template&id=1faeff76&"
import script from "./scan-fingerprint.vue?vue&type=script&lang=js&"
export * from "./scan-fingerprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports